import Box from '@mui/material/Box';
import * as React from 'react';
import { sxfw } from '../Interfaces';
export const TheLegend = () => {
    return (
        <Box sx={sxfw} minWidth={200} maxWidth={350}>
        <div className='highlighted-row' style={{ padding: '2px 10px', margin: '2px 5px'}}>Letzte Meldung älter als 36 Stunden.</div>

        <div className='highlightedGreen-row'  style={{ padding: '2px 10px', margin: '2px 5px'}}>Meldung kürzlich erfolgt.</div>
      </Box>
    );
};